import { ITALIAN_ASSOCIATION_LEGAL_CODES } from './legal-codes';

// According to the Product Team the below codes do not need to be displayed:
const excludedItalianAssociationLegalCodes = ['AI', 'PA'];
const italianAssociationLegalCodes = ITALIAN_ASSOCIATION_LEGAL_CODES.filter(
  code => !excludedItalianAssociationLegalCodes.includes(code)
);

// The below codes are used on the legal form dropdown when editing an organization:
export const companyTypes = {
  ES: [
    'ESC01',
    'ESC02',
    'ESC04',
    'ESC06',
    'ESC07',
    'ESC09',
    'ESC10',
    'ESC11',
    'ESC12',
    'ESC13',
    'ESC14',
    'ESC15',
    'ESC30',
    'ESC100',
  ],
  FR: [
    '5720',
    '5499',
    '5710',
    '1000',
    '5498',
    '1500',
    '1300',
    '6540',
    '6599',
    '5599',
    '5202',
    '5306',
    '3120',
    '6220',
    '7323',
    '9224',
    '9220',
    '9221',
    '9230',
    '9222',
    '7321',
    '9150',
  ],
  IT: [
    'IT001',
    'IT002',
    'IT401',
    'IT201',
    'IT301',
    'IT701',
    'IT702',
    'IT703',
    'IT704',
    'IT705',
    ...italianAssociationLegalCodes,
  ],
  DE: [
    'DE206',
    'DE002',
    'DE101',
    'DE207',
    'DE001',
    'DE210',
    'DE208',
    'DE201',
    'DE111',
    'DE105',
    'DE106',
    'DE107',
    'DE103',
    'DE102',
    'DE108',
    'DE112',
    'DE202',
    'DE110',
    'DE201:110',
    'DE602',
  ],
} as const;

export const EINZELUNTERNEHMER_LEGAL_CODE = 'DE002';
export const SOLOPRENEURS_GERMANY_LEGAL_NAMES = [
  'Einzelunternehmer',
  'Freiberufler',
  'einzelunternehmer',
  'freiberufler',
];
export const LEGAL_ENTITIES_GERMANY_NAMES = ['GmbH', 'Gmbh', 'gmbh', 'UG', 'ug'];
export const FREIBERUFLER_LEGAL_CODE = 'DE210';
export const GBR_LEGAL_CODE = 'DE101';
export const GMBH_IN_IG_LEGAL_CODE = 'DE306';
export const UG_IN_IG_LEGAL_CODE = 'DE307';

type CompanyTypes = typeof companyTypes;
export type CountryCodes = keyof CompanyTypes;
export type AllLegalCodes = CompanyTypes[CountryCodes][number];

export const LEGAL_CODES_SUFFIXES: Partial<Record<AllLegalCodes, string>> = {
  AC: '_lowercase',
  OO: '_lowercase',
  SC: '_lowercase',
};

export const LEGAL_CODES_INELIGIBLE_FOR_CAPITAL_INCREASE_FR = [
  '9210',
  '9223',
  '9240',
  '9260',
  '9300',
  '8310',
  '8311',
  '8410',
  '8420',
  '8450',
  '8470',
  '8490',
  '9150',
  '9220',
  '9221',
  '9222',
  '9224',
  '9230',
  '1000',
  '1100',
  '1200',
  '1300',
  '1500',
  '1900',
  '5195',
  'QONTO-TMP-001',
];
